import { render, staticRenderFns } from "./ChartWidgetCaseType.vue?vue&type=template&id=16b07400&scoped=true&"
import script from "./ChartWidgetCaseType.vue?vue&type=script&lang=js&"
export * from "./ChartWidgetCaseType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b07400",
  null
  
)

export default component.exports